import { combineReducers } from 'redux';

import companyAccount from './company-account-reducer';

export default combineReducers({
  companyAccount,
});
